import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig> {
  scrollBehaviorType: 'smooth',
  // scrollBehavior: async (to, from, savedPosition) => {
  //   await new Promise(resolve => setTimeout(resolve, 250))
  //   return {
  //     left: savedPosition?.left || 0,
  //     top: savedPosition?.top || 0,
  //   }
  // },
}
